import {useEffect} from 'react';

const useClickOutsideOf = <T extends HTMLElement | null>(ref: React.RefObject<T>, callback: () => void, hasMetCondition = false) => {
  useEffect(() => {
    if (!hasMetCondition) {
      return;
    }
    const handleClick = (e: MouseEvent) => {
      const isClickedOutside = ref.current && !ref.current.contains(e.target as Node | null);
      if (isClickedOutside) callback();
    };
    const timeout = setTimeout(() => {
      document.addEventListener('click', handleClick);
    }, 0);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('click', handleClick);
    };
  }, [hasMetCondition, callback]);
};

export default useClickOutsideOf;
